import styled from 'styled-components'

export const Box = styled.div`
  flex: 1;
  width: 386px;
  margin-bottom: 60px;
`
